export default {
  // AUTH
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SAVE_ID_TOKEN: 'SAVE_ID_TOKEN',

  // TRAINING
  SET_LESSONS: 'SET_LESSONS',
  SET_LESSONS_SRC: 'SET_LESSONS_SRC',
  NEW_LESSON: 'NEW_LESSON'
}



// WEBPACK FOOTER //
// ./src/constants.js